import discovery from '../../seo/discovery.json'

export const AEO_SITE_URL = discovery.site_url
export const AEO_FAQ = discovery.faq
export const AEO_ENTITIES = discovery.entities

export function aeo_faq_json_ld(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: AEO_FAQ.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  }
}